import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { SuggestionForm } from '@features/tsp/suggest';
import { Modal, ModalProps, ModalWrapper } from '@shared/ui/organisms';
import SuggestionNotSentContent from './SuggestionNotSentContent';
import SuggestionSentContent from './SuggestionSentContent';
type SuggestTspModalDesktopProps = ModalProps;
const SuggestTspModalDesktop: FC<SuggestTspModalDesktopProps> = ({
  onClose,
  ...props
}) => <Modal onClose={onClose} {...props}>
    <ModalWrapper>
      <SuggestWindowWrapper>
        <SuggestionForm renderContent={({
        isSuggestionSent
      }) => isSuggestionSent ? <SuggestionSentContent onClose={onClose} /> : <SuggestionNotSentContent onClose={onClose} />} />
      </SuggestWindowWrapper>
    </ModalWrapper>
  </Modal>;
export default SuggestTspModalDesktop;
const SuggestWindowWrapper = /*#__PURE__*/styled('div')({
  name: "SuggestWindowWrapper",
  class: "svffwl2",
  propsAsIs: false
});

require("./SuggestTspModalDesktop.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SuggestTspModalDesktop.tsx");